import { render, staticRenderFns } from "./lp-attendee-card.vue?vue&type=template&id=3f98ef8c&"
import script from "./lp-attendee-card.vue?vue&type=script&lang=js&"
export * from "./lp-attendee-card.vue?vue&type=script&lang=js&"
import style0 from "./lp-attendee-card.vue?vue&type=style&index=0&id=3f98ef8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports